import { FlexBox } from "@brg/ui";
import styled, { css } from "styled-components";
import { ReactComponent as StarIcon } from "../../../components/InteractiveTabs/images/starIcon.svg";
import { useSelector } from "react-redux";
import { ThemeSlideColorSelector } from "../../../reducers/ThemeSlideColorSlice";
import { LayoutConst } from "../../../../core";

const GridTitleText = styled(FlexBox)`
  font-family: Inter;
  font-size: 43px;
  font-style: normal;
  font-weight: 600;
  line-height: 51px; /* 118.605% */
  letter-spacing: -0.86px;
`

const GridTitleContainer = styled(FlexBox)<{ color?: string }>`
  margin-top: 16px;
  align-items: center;

  svg {
    margin-right: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    svg {
      margin-right: 12px;
      height: 40px;
      width: 40px;
    }
    
    ${GridTitleText} {
      font-size: 30px;
      line-height: 33px;
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 16px;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    svg {
      margin-right: 8px;
      height: 24px;
      width: 24px;
    }

    ${GridTitleText} {
      font-size: 20px;
      line-height: 25px;
    }
  }
  
  ${({ color }) => color && css`
    color: ${color};

    svg {
      path {
        fill: ${color};
      }
    }
  `}
`

const GridTitle = ({ title }: any) => {
  const color = useSelector(ThemeSlideColorSelector)?.slideColor?.color;
  return (
    <GridTitleContainer color={color}>
      <StarIcon/>
      <GridTitleText>
        {title}
      </GridTitleText>
    </GridTitleContainer>
  )
};

export default GridTitle;import { FlexBox } from "@brg/ui";
import styled, { css } from "styled-components";
import { ReactComponent as StarIcon } from "../../../components/InteractiveTabs/images/starIcon.svg";
import { useSelector } from "react-redux";
import { ThemeSlideColorSelector } from "../../../reducers/ThemeSlideColorSlice";
import { LayoutConst } from "../../../../core";

const GridTitleText = styled(FlexBox)`
  font-family: Inter;
  font-size: 43px;
  font-style: normal;
  font-weight: 600;
  line-height: 51px; /* 118.605% */
  letter-spacing: -0.86px;
`

const GridTitleContainer = styled(FlexBox)<{ color?: string }>`
  margin-top: 16px;
  align-items: center;

  svg {
    margin-right: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    svg {
      margin-right: 12px;
      height: 40px;
      width: 40px;
    }
    
    ${GridTitleText} {
      font-size: 30px;
      line-height: 33px;
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 16px;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    svg {
      margin-right: 8px;
      height: 24px;
      width: 24px;
    }

    ${GridTitleText} {
      font-size: 20px;
      line-height: 25px;
    }
  }
  
  ${({ color }) => color && css`
    color: ${color};

    svg {
      path {
        fill: ${color};
      }
    }
  `}
`

const GridTitle = ({ title }: any) => {
  const color = useSelector(ThemeSlideColorSelector)?.slideColor?.color;
  return (
    <GridTitleContainer color={color}>
      <StarIcon/>
      <GridTitleText>
        {title}
      </GridTitleText>
    </GridTitleContainer>
  )
};

export default GridTitle;